import React from "react";
import { Page } from "../../components/page/page";
import styles from "./symbols.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSymbols } from "../../store/stateSlice";

const options = [
  {
    value: "Yes, I frequently notice symbols",
    icon: "🤩",
  },
  {
    value: "Sometimes, but I don't know why",
    icon: "😌",
  },
  {
    value: "I rarely notice symbols and signs",
    icon: "🙂",
  },
  {
    value: "Not sure",
    icon: "🤔",
  },
];

const SymbolsPage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="Do you feel a connection to symbols and signs around you?"
      hideContinueButton={true}
      currentStep={13}
    >
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to="../moon"
              onClick={() => dispatch(setSymbols(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { SymbolsPage };
